import { useEffect, useState } from 'react';
import { createRootModal } from '../../RootModal';

import { useDispatch, useSelector } from 'react-redux';
import Button from '../../../../components/Button';
import UploadFiles from '../../../../components/UploadFiles/UploadFiles';
import { t } from '../../../../lang';
import RequestService from '../../../../services/RequestService';
import { sendSlice } from '../../../../store/slices';
import './TransactionFilesModal.scss';

const MAX_FILE_SIZE = 10 * 1024 * 1024;

const TransactionFilesModal = createRootModal(({ handleClose }) => {
	const [files, setFiles] = useState([]);
	//Test
	const uploadFiles = useSelector(store => store.send.approvalFiles);

	const dispatch = useDispatch();

	useEffect(() => {
		if (uploadFiles?.length) {
			const mapped = uploadFiles.map(file => ({
				tempId: crypto.randomUUID(),
				id: file.Id,
				name: file.FileName,
				size: file.Size,
				status: 'Success',
			}));

			setFiles(mapped);
		}
	}, []);

	const mockUploadApprovalFiles = () => {
		return new Promise((resolve, reject) => {
			setTimeout(() => {
				const isError = Math.random() < 0.1;

				if (isError) {
					reject({
						Status: 'Error',
						ErrorMessage: 'Upload failed',
					});
				} else {
					resolve({
						Id: crypto.randomUUID(),
						Status: 'Success',
					});
				}
			}, 1500);
		});
	};

	const mockDeleteApprovalFile = id => {
		return new Promise(resolve => {
			setTimeout(() => {
				resolve({ Status: 'Success' });
			}, 800);
		});
	};

	const handleUpload = async selectedFiles => {
		for (const file of selectedFiles) {
			const tempId = crypto.randomUUID();

			const isTooLarge = file.size > MAX_FILE_SIZE;

			setFiles(prev => [
				...prev,
				{
					tempId,
					name: file.name,
					size: file.size,
					status: isTooLarge ? 'Error' : 'Loading',
					serverId: null,
				},
			]);

			if (isTooLarge) {
				continue;
			}

			try {
				const response = await RequestService.UploadFile(file);

				if (response.Status === 'Success') {
					setFiles(prev =>
						prev.map(item =>
							item.tempId === tempId
								? {
										...item,
										status: response.Status,
										serverId: response.Id,
								  }
								: item
						)
					);

					dispatch(
						sendSlice.actions.addApprovalFile({
							Id: response.Id,
							FileName: file.name,
							Size: file.size,
							deleteStatus: file.deleteStatus,
						})
					);
				} else {
					setFiles(prev =>
						prev.map(item =>
							item.tempId === tempId
								? {
										...item,
										status: response.Status,
										serverId: response.Id,
								  }
								: item
						)
					);
				}
			} catch (e) {
				setFiles(prev => prev.map(item => (item.tempId === tempId ? { ...item, status: 'Error' } : item)));
			}
		}
	};

	const handleDelete = async file => {
		// setFiles(prev => prev.filter(file => file.id !== id));
		if (file.id) {
			try {
				// await mockDeleteApprovalFile(id)

				dispatch(sendSlice.actions.setApprovalFiles(uploadFiles.filter(item => item.Id !== file.id)));
			} catch (e) {
				console.log('error');
				return;
			}
		}

		setFiles(prev => prev.filter(item => item.tempId !== file.tempId));
	};

	console.log('Uploaded files: ', uploadFiles);

	return (
		<>
			<UploadFiles files={files} onUpload={handleUpload} onDelete={handleDelete} />
			<div className='TransactionFiles__button'>
				<Button disabled={files.length === 0} onClick={handleClose}>
					{t('Attach files')}
				</Button>
			</div>
		</>
	);
});

export default TransactionFilesModal;
